import React from 'react';
import PropTypes from 'prop-types';
import './CustomInput.css';

function CustomInput({
  icon: Icon,
  placeholder,
  baseClass = 'custom-input',
  hoverClass,
  activeClass,
  borders = '',
  bordersClassPrefix = 'border-black-',
  value,
  onChange,
  onFocus,
  onBlur,
}) {
  // Generowanie klas dla ramek na podstawie borders
  const borderClasses = borders
    .split('')
    .map((char) => `${bordersClassPrefix}${char}`)
    .join(' ');

  return (
    <div className={`${baseClass} ${activeClass} ${borderClasses}`}>
      {Icon && <Icon className="input-icon" />}
      <input
        type="text"
        className="input-field"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onMouseEnter={(e) => e.currentTarget.parentElement.classList.add(hoverClass)}
        onMouseLeave={(e) => e.currentTarget.parentElement.classList.remove(hoverClass)}
      />
    </div>
  );
}

CustomInput.propTypes = {
  icon: PropTypes.elementType, // Komponent ikony
  placeholder: PropTypes.string.isRequired, // Tekst placeholdera
  baseClass: PropTypes.string, // Klasa podstawowego wyglądu (opcjonalna, z domyślną wartością)
  hoverClass: PropTypes.string.isRequired, // Klasa dla hover
  activeClass: PropTypes.string, // Klasa dla stanu aktywnego
  borders: PropTypes.string, // Ciąg znaków definiujący ramki (np. "LRBT")
  bordersClassPrefix: PropTypes.string, // Prefiks klas dla ramek
  value: PropTypes.string.isRequired, // Wartość pola tekstowego
  onChange: PropTypes.func.isRequired, // Funkcja wywoływana przy zmianie wartości
  onFocus: PropTypes.func, // Funkcja wywoływana przy focusie
  onBlur: PropTypes.func, // Funkcja wywoływana przy blurze
};

CustomInput.defaultProps = {
  baseClass: 'custom-input', // Domyślna wartość dla baseClass
  borders: '', // Domyślnie brak ramek
  bordersClassPrefix: 'border-black-', // Domyślny prefiks dla klas ramek
  activeClass: '', // Domyślnie brak klasy aktywnej
  onFocus: () => {}, // Domyślna funkcja focus
  onBlur: () => {}, // Domyślna funkcja blur
};

export default CustomInput;